import { customerDashboardMenu, defaultDashboardMenu, partnerDashboardMenu } from "./sidebarcomponents/menuConfig";

//user type list

// [
//     {
//         "name": "Superuser",
//         "value": 0
//     },
//     {
//         "name": "Sub Admin",
//         "value": 1
//     },
//     {
//         "name": "Partner Admin",
//         "value": 2
//     },
//     {
//         "name": "Partner User",
//         "value": 3
//     },
//     {
//         "name": "Customer Admin",
//         "value": 4
//     },
//     {
//         "name": "Customer User",
//         "value": 5
//     }
// ]

export const getMenuItemsByUserType = (userType, permissionConfig, partnerCustomer, userPermissions) => {

  // User types 0, 1, 5 → customerDashboardMenu
  // User types 2, 3, 4 → partnerDashboardMenu
  const isCustomerType = [0, 1, 4, 5].includes(userType);
  const isPartnerType = [2, 3].includes(userType);

  const menuGenerator = isCustomerType
    ? customerDashboardMenu
    : isPartnerType
      ? partnerDashboardMenu
      : defaultDashboardMenu; // fallback

  return menuGenerator(permissionConfig, userType, partnerCustomer, userPermissions);
};
